var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Settings",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M48,29.81c0,1.48,0,3,0,4.44a1.53,1.53,0,0,1-1.52,1.56H44.64a.31.31,0,0,0-.36.24c-.24.6-.48,1.2-.76,1.8,0,.16-.08.24.08.36.44.44.84.84,1.24,1.28a1.47,1.47,0,0,1,0,2.28l-3.16,3.16a1.52,1.52,0,0,1-2.16,0c-.44-.44-.88-.92-1.32-1.36a.19.19,0,0,0-.28,0c-.64.28-1.28.52-1.92.76-.16.08-.2.12-.2.28v1.88A1.45,1.45,0,0,1,34.4,48Q32,48,29.6,48a1.44,1.44,0,0,1-1.4-1.48V44.41c-.76-.32-1.44-.6-2.16-.92a.43.43,0,0,0-.24.08c-.44.44-.88.88-1.28,1.32a1.55,1.55,0,0,1-2.24,0L19.2,41.81a1.52,1.52,0,0,1,0-2.4l1.2-1.2a.26.26,0,0,0,.08-.32c-.28-.64-.56-1.28-.8-1.92,0-.12-.24-.16-.24-.16-.6,0-1.2,0-1.8,0A1.57,1.57,0,0,1,16,34.17c0-1.48,0-2.92,0-4.4a1.5,1.5,0,0,1,1.6-1.56c.64,0,1.32,0,2,0,0-.08,0-.16.08-.2.24-.64.48-1.24.76-1.88.08-.16.08-.24-.08-.4l-1.2-1.2a1.52,1.52,0,0,1,0-2.32l3.12-3.12a1.52,1.52,0,0,1,2.16,0c.44.44.88.84,1.32,1.32a.3.3,0,0,0,.36,0l1.76-.72a.4.4,0,0,0,.32-.44c0-.6,0-1.2,0-1.8A1.49,1.49,0,0,1,29.6,16h4.8a1.49,1.49,0,0,1,1.4,1.48v2a.22.22,0,0,0,.16.24c.68.24,1.32.52,2,.8a.74.74,0,0,0,.28-.08c.44-.4.84-.84,1.28-1.28a1.48,1.48,0,0,1,2.24,0c1,1,2,2,3.08,3a1.54,1.54,0,0,1,0,2.44c-.48.44-.92.88-1.32,1.28.28.76.56,1.48.88,2.16,0,.08.2.12.2.12a13.52,13.52,0,0,0,1.8,0A1.59,1.59,0,0,1,48,29.81ZM40,32a8,8,0,1,0-8,8A8,8,0,0,0,40,32Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/settings.svg